import { Asimovian, Sofia_Sans, Sofia_Sans_Condensed } from 'next/font/google';

const displayFont = Asimovian({
  weight: ['400'],
  style: ['normal'],
  subsets: ['latin'],
  display: 'swap',
  adjustFontFallback: false, // Asimovian is too new for Next.js fallback metrics
  fallback: ['Arial', 'sans-serif'], // Turbopack skips metrics lookup when fallback is set
  //preload: true,
});

const bodyFont = Sofia_Sans({
  weight: ['400', '800'],
  style: ['normal', 'italic'],
  subsets: ['latin'],
  display: 'swap',
  //preload: true,
});

const condensedFont = Sofia_Sans_Condensed({
  weight: ['400'],
  style: ['normal'],
  subsets: ['latin'],
  display: 'swap',
  //preload: false,
});

const typography = {
  fontFamily: bodyFont.style.fontFamily,
  h1: {
    fontFamily: displayFont.style.fontFamily,
    fontSize: '2.6rem !important',
    fontWeight: 400,
  },
  h2: {
    fontFamily: displayFont.style.fontFamily,
    fontSize: '2.3rem !important',
    fontWeight: 400,
  },
  h3: {
    fontFamily: displayFont.style.fontFamily,
    fontSize: '2rem !important',
    fontWeight: 400,
  },
  h4: {
    fontFamily: displayFont.style.fontFamily,
    fontSize: '1.6rem !important',
    fontWeight: 400,
  },
  h5: {
    fontFamily: displayFont.style.fontFamily,
    fontSize: '1.25rem',
    fontWeight: 400,
  },
  h6: {
    fontFamily: displayFont.style.fontFamily,
    fontSize: '1.125rem',
  },
  subtitle1: {
    fontFamily: bodyFont.style.fontFamily,
    fontSize: '1.3rem',
    lineHeight: '1.4',
    fontWeight: 400,
    letterSpacing: '0.02rem',
  },
  subtitle2: {
    fontFamily: bodyFont.style.fontFamily,
    fontSize: '1.2rem',
    lineHeight: '1.3',
    fontWeight: 400,
    letterSpacing: '0.02rem',
  },
  condensed6: {
    fontFamily: condensedFont.style.fontFamily,
    fontSize: '1rem',
    fontWeight: 400,
    letterSpacing: '0.02rem',
  },
  condensed5: {
    fontFamily: condensedFont.style.fontFamily,
    fontSize: '1.2rem',
    fontWeight: 400,
    letterSpacing: '0.02rem',
  },
  condensed4: {
    fontFamily: condensedFont.style.fontFamily,
    fontSize: '1.4rem',
    fontWeight: 400,
    letterSpacing: '0.02rem',
  },
  body1: {
    fontFamily: bodyFont.style.fontFamily,
    fontSize: '1rem',
    letterSpacing: '0.15px',
  },
  body2: {
    fontFamily: bodyFont.style.fontFamily,
    fontSize: '0.875rem',
    letterSpacing: '0.15px',
  },
  button: {
    fontFamily: displayFont.style.fontFamily,
    fontSize: '1rem',
    fontWeight: 400,
    letterSpacing: '0.3px',
  },
  caption: {
    fontFamily: bodyFont.style.fontFamily,
    fontSize: '0.75rem',
    letterSpacing: '0.4px',
  },
  overline: {
    fontFamily: bodyFont.style.fontFamily,
    fontSize: '0.75rem',
    letterSpacing: '1px',
  },
};

export default typography;
